<template>
  <div
    class="mine_conten"
    :style="{
      paddingBottom: ['3.8', '3.8_2'].includes(config?.ui_version)
        ? '0.8rem'
        : '1.24rem'
    }"
  >
    <div
      class="CToeIaCnZ7Jr3D1XKTxw"
      :style="`background-image:url(${coloImgactivity});`"
      style="
        background-position: 0 0;
        background-size: 100% 100%;
        padding-top: 0.12rem;
        padding-bottom: 0;
      "
    >
      <div
        style="
          padding: 0.16rem 0.14rem;
          width: 0.32rem;
          height: 0.32rem;
          box-sizing: content-box;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.24rem;
          z-index: 2;
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          color: var(--theme-text-color-darken);
        "
        @click="goBack"
      >
        <svg-icon
          className="imageWrap"
          icon-class="comm_icon_fh--svgSprite:all"
          style="width: 0.22rem; height: 0.22rem"
        />
      </div>
      <header
        class="DiNiMDlhVGqZnjLoStS4"
        style="color: var(--theme-text-color-darken); padding: 0 0.2rem"
      >
        <div class="flex justify-center items-center">
          <div class="So_waOZgg7qEl0wURIQz" @click="openUrl('notice')">
            <div class="" style="color: var(--theme-text-color-darken)">
              <svg-icon
                slot="left-icon"
                style="width: 0.48rem; height: 0.48rem; margin-left: 0.3rem"
                classNameQita
                icon-class="icon-mine30KF"
              />
            </div>
          </div>
          <div
            class="So_waOZgg7qEl0wURIQz"
            @click="openUrl('notice', { active: 1 })"
          >
            <div class="HY5zlQQwDl4OlzKNd0jr" style="position: relative">
              <div class="" style="color: var(--theme-text-color-darken)">
                <svg-icon
                  slot="left-icon"
                  style="width: 0.48rem; height: 0.48rem; margin-left: 0.3rem"
                  classNameQita
                  icon-class="icon-mine30Email"
                />
              </div>
            </div>
          </div>
        </div>
      </header>
      <div style="position: relative; width: 100%; min-height: 1.44rem">
        <div
          style="
            position: relative;
            z-index: 2;
            display: flex;
            align-items: center;
            padding: 0.1rem 0.44rem;
            color: #d48c0b;
            font-size: 0.24rem;
            height: 1.6rem;
            background-size: 100% 100%;
            background-position: 0px 0px;
            background-repeat: no-repeat;
          "
          :style="`background-image:url(${mineBoxBgImg});`"
        >
          <div style="position: relative; width: 1.12rem; height: 1.12rem">
            <img
              src="../../assets/mine30/mine30VIPBg.webp"
              alt=""
              style="
                width: 1.12rem;
                height: 1.12rem;
                position: absolute;
                top: 0;
                right: 0;
              "
            />
            <img
              src="../../assets/mine30/mine30VIP.webp"
              alt=""
              style="
                width: 1.12rem;
                height: 1.12rem;
                position: absolute;
                top: 0;
                right: 0;
              "
            />
            <div
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: #fff;
                width: 50%;
                text-align: center;
                font-weight: 700;
                text-shadow: 0 0.01rem 0 rgba(0, 0, 0, 0.4);
                direction: ltr;
                font-size: 0.21rem;
              "
            >
              {{ userInfo?.vip_info?.level }}
            </div>
          </div>
          <div
            style="
              display: flex;
              flex: 1;
              flex-direction: column;
              justify-content: center;
              margin-left: 0.16rem;
            "
          >
            <div
              class="_header_d6bzd_52 _vipTheme3_d6bzd_162 _vipTip_t3re3_184"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  font-size: 0.22rem;
                  line-height: 1;
                  justify-content: space-between;
                  flex: 1;
                "
              >
                <p
                  style="
                    flex: 1;
                    unicode-bidi: plaintext;
                    display: -webkit-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    vertical-align: middle;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    text-align: left;
                  "
                >
                  <span>Restantes</span
                  ><sapn
                    style="color: #442e03; font-weight: 700; margin: 0 0.05rem"
                    >VIP {{ userInfo?.vip_info?.next_level }}</sapn
                  ><span style="display: none;">Deposite mais</span
                  ><span
                    style="color: #442e03; font-weight: 700; margin: 0 0.05rem;display: none;"
                    >{{ userInfo?.vip_info?.upneed_recharge }}</span
                  ><span>Você precisa apostar</span
                  ><span
                    style="color: #442e03; font-weight: 700; margin: 0 0.05rem"
                    >{{ userInfo?.vip_info?.upwhere_bet }}</span
                  >
                </p>
                <div
                  style="
                    padding: 0.16rem 0.14rem;
                    width: 0.32rem;
                    height: 0.32rem;
                    box-sizing: content-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.24rem;
                    z-index: 2;
                    cursor: pointer;
                  "
                  @click="$router.push('/vip')"
                >
                  <svg-icon
                    className="imageWrap"
                    icon-class="comm_icon_fh--svgSprite:all"
                    style="
                      width: 0.22rem;
                      height: 0.22rem;
                      transform: rotate(180deg);
                    "
                  />
                </div>
              </div>
              <div class="nUtoDOFYqni_cq_dHUjg" style="display: none;">
                <div class="i9WaVhztJIXx90Q1PPLD">
                  <span
                    class="N4LsWhJBhqqyTkv6V0NE auto-shrink-text Rp9bR9P03_qFsh1PnGSc"
                    style="
                      width: 100%;
                      margin-bottom: -1.22353px;
                      padding-bottom: 1.22353px;
                    "
                  >
                    <span class="ke1kCzBARxq5HSxbDQ6h">
                      <span
                        class="TMZWYZcIv5YQXVdFMVrw inner-text"
                        style="-webkit-line-clamp: 2"
                      >
                        {{ $t('mine._DepositPromotion') }}
                      </span>
                    </span>
                  </span>
                  <div class="J5dtKM_LB6fse7jhX2hk FPKXpabqN25lBr4IA7LQ">
                    <div
                      class="MtFB4D3SHXXdqKU0qelp SC6yMRCGE2upeyEdgibm"
                      :style="{
                        width: `${
                          (removeThousandSeparatorAndDecimalPoint(
                            userInfo.vip_info.now_recharge
                          ) /
                            removeThousandSeparatorAndDecimalPoint(
                              userInfo.vip_info.upwhere_recharge
                            )) *
                          100
                        }%`
                      }"
                    ></div>
                    <span class="kNDhRFHNQ398GxjnCVlg u5sLSrD0KWEulumHoUzc">
                      {{ userInfo.vip_info.now_recharge }}/
                      {{ userInfo.vip_info.upwhere_recharge }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="nUtoDOFYqni_cq_dHUjg">
                <div class="i9WaVhztJIXx90Q1PPLD">
                  <span
                    class="N4LsWhJBhqqyTkv6V0NE auto-shrink-text Rp9bR9P03_qFsh1PnGSc"
                    style="
                      width: 100%;
                      margin-bottom: -1.22353px;
                      padding-bottom: 1.22353px;
                    "
                  >
                    <span class="ke1kCzBARxq5HSxbDQ6h">
                      <span
                        class="TMZWYZcIv5YQXVdFMVrw inner-text"
                        style="-webkit-line-clamp: 2"
                      >
                        {{ $t('mine._Apostaparapromoção') }}
                      </span>
                    </span>
                  </span>
                  <div class="J5dtKM_LB6fse7jhX2hk FPKXpabqN25lBr4IA7LQ">
                    <div
                      class="MtFB4D3SHXXdqKU0qelp SC6yMRCGE2upeyEdgibm"
                      :style="{
                        width: `${
                          (removeThousandSeparatorAndDecimalPoint(
                            userInfo.vip_info.now_bet
                          ) /
                            removeThousandSeparatorAndDecimalPoint(
                              userInfo.vip_info.upwhere_bet
                            )) *
                          100
                        }%`
                      }"
                    ></div>
                    <span class="kNDhRFHNQ398GxjnCVlg u5sLSrD0KWEulumHoUzc">
                      {{ userInfo.vip_info.now_bet }}/
                      {{ userInfo.vip_info.upwhere_bet }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="vuex_token_head"
      class="CToeIaCnZ7Jr3D1XKTxw"
      style="
        flex-direction: row;
        justify-content: left;
        padding: 0.2rem 0.26rem;
      "
    >
      <div class="SVLWJ4WJI54O4lWBc7yk">
        <div class="P_VF1DJcPs_q4ieRYz7n">
          <img
            style="width: 100%; height: 100%; border-radius: 50%"
            :src="$store.state.config.user_avatar_image"
            alt=""
          />
          <div
            class="flex justify-center items-center"
            style="
              width: 0.4rem;
              height: 0.4rem;
              border-radius: 50%;
              background: var(--theme-mine-icon-color);
              position: absolute;
              bottom: 0;
              right: 0;
            "
            @click="jumpUrl('setting')"
          >
            <svg-icon
              slot="left-icon"
              style="
                width: 0.4rem;
                height: 0.4rem;
                cursor: pointer;
                color: var(--theme-btm-bg-color);
              "
              classNameQita
              icon-class="icon-mine-edit"
            />
          </div>
        </div>
        <div class="zvrVqQuEWSzu7Nsavegl">
          <div
            class="NeL_d0h5i7Kr9xdDCTty flex items-center"
            style="position: relative"
          >
            <div
              class="B8Z5jNPFB44UUahGOFBH EpCtJEz_E_WMlMB6HeaI flex items-center"
              style="cursor: pointer"
              @click="isShowChoose = true"
            >
              <svg-icon
                slot="left-icon"
                style="width: 0.15rem; height: 0.15rem; transition: 500ms"
                classNameQita
                icon-class="icon-mine-down"
                :style="{ transform: isShowChoose ? 'rotate(180deg)' : '' }"
              />
            </div>
            <div class="flex items-center" v-if="chooseInfo == 'name'">
              <span class="PIj1PfbzHvacLB3SeEjQ">{{ userInfo.user_name }}</span>
              <span
                @click="copyContent(userInfo.user_name)"
                class="wJ30VxmrZK3Y5gTd1Zq0"
              >
                <svg-icon
                  slot="left-icon"
                  style="width: 0.28rem; height: 0.28rem; cursor: pointer"
                  classNameQita
                  icon-class="icon-copy"
                />
              </span>
            </div>
            <div class="flex items-center" v-else>
              <span class="PIj1PfbzHvacLB3SeEjQ">{{ userInfo.phone }}</span>
            </div>
            <div
              v-if="isShowChoose"
              style="
                width: 100dvw;
                height: 100dvh;
                position: fixed;
                left: 0;
                top: 0;
              "
              @click="isShowChoose = false"
            ></div>
            <div
              v-if="isShowChoose"
              style="
                border-radius: 0.14rem;
                box-shadow: 0 0.04rem 0.12rem rgba(0, 0, 0, 0.1);
                border: 0.01rem solid var(--theme-color-line);
                background: var(--theme-text-color-darken);
                padding: 0.2rem 0.2rem 0.15rem;
                display: flex;
                flex-direction: column;
                min-width: 4.2rem;
                position: absolute;
                top: 0.35rem;
                left: 0;
                z-index: 100;
              "
            >
              <div style="margin-bottom: 0.14rem; color: #fff">
                {{ $t('common.mineText2') }}
              </div>
              <div
                class="flex items-center"
                style="gap: 0.1rem; height: 0.8rem"
                :style="{
                  color:
                    chooseInfo == 'name'
                      ? 'var(--theme-mine-icon-color)'
                      : 'var(--theme-text-color)'
                }"
                @click="(chooseInfo = 'name'), (isShowChoose = false)"
              >
                <svg-icon
                  className="imageWrap"
                  style="width: 0.3rem; height: 0.3rem"
                  icon-class="input_icon_zh--svgSprite:all"
                />
                <span>{{ userInfo.user_name }}</span>
              </div>
              <div
                class="flex items-center"
                style="gap: 0.1rem; height: 0.8rem"
                :style="{
                  color:
                    chooseInfo == 'phone'
                      ? 'var(--theme-mine-icon-color)'
                      : 'var(--theme-text-color)'
                }"
                @click="(chooseInfo = 'phone'), (isShowChoose = false)"
              >
                <svg-icon
                  slot="left-icon"
                  style="width: 0.3rem; height: 0.3rem"
                  classNameQita
                  icon-class="icon-mine-phone"
                />
                <span>{{ userInfo.phone }}</span>
              </div>
            </div>
          </div>
          <div class="Fn6L7w5ZEXiwo2fTNrRn">
            <div class="glbY5bkp9x7KTYOGrdBC">
              <span class="B8Z5jNPFB44UUahGOFBH EpCtJEz_E_WMlMB6HeaI">ID:</span
              ><span class="PIj1PfbzHvacLB3SeEjQ">{{ userInfo.id }}</span>
              <div
                @click="copyContent(userInfo.id)"
                class="wJ30VxmrZK3Y5gTd1Zq0 flex justify-center items-center"
              >
                <svg-icon
                  slot="left-icon"
                  style="width: 0.28rem; height: 0.28rem; cursor: pointer"
                  classNameQita
                  icon-class="icon-copy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Fn6L7w5ZEXiwo2fTNrRn" style="margin-left: 0.5rem">
        <div class="glbY5bkp9x7KTYOGrdBC">
          <i data-id="sprite_main_flag_1x1_Brazil" aria-hidden="true" focusable="false" class=""
								:style="`display: inline-block; position: relative; width: 0.34rem; height: 0.34rem; background-image: url(${_coloImg}); background-position: ${conutryPosion}; background-size: 8.81571rem 8.60321rem;`"></i>
          <span
            style="
              color: #fff;
              opacity: 0.1;
              margin-left: 0.02rem;
              width: 0.01rem;
              flex-shrink: 0;
              position: relative;
              top: -0.02rem;
            "
            >|</span
          >
          <div
            class="vy918omw_N7rBkJ235XX IMl873FTgqqNlSitFJrT iyrfQ72Vih_uHUFOsiR4 currencyInfoBox main VOgj9FBCnkozjr2NA7rl"
            style="--row-align: center; --mode: flex; --column-align: center"
          >
            <section
              class="iw9FDOIygJyoQtUHSJAg currency-count"
              style="font-size: 0.18rem"
            >
              <div class="countTextBox">
                <span
                  class="SSAbrhtT3U690CrzLUd5 SSYrjrFkdeGEfKeXOPu3 count-to"
                >
                  <span class="notranslate">{{ userBalance }}</span>
                </span>
                <div
                  class="refresh-icon"
                  :class="{
                    animate__manimated: animate__manimated
                  }"
                  @click="animate_conter"
                >
                  <svg-icon
                    className="refresh-icon"
                    style="cursor: pointer"
                    icon-class="style_1_icon_sx--svgSprite:all"
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: auto;
        color: var(--theme-text-color-darken);
        margin-top: 0.1rem;
        padding-bottom: 0.1rem;
      "
    >
      <div
        class="moneybox moneybox1"
        @click="
          jumpUrl(userInfo.set_withdraw_password ? 'withdraw' : 'security')
        "
      >
        <svg-icon
          style="
            width: 0.53rem;
            height: 0.53rem;
            font-size: 0.53rem;
            cursor: pointer;
          "
          classNameQita
          icon-class="icon-mine30Saques"
        />
        <span>
          {{ $t('_home._Saques') }}
        </span>
      </div>
      <div class="moneybox" style="margin-right: 0.14rem" @click="showDeposit">
        <img src="../../assets/mine30/mine30Deposit.webp" alt="" />
        <span>
          {{ $t('mine._Depósito') }}
        </span>
      </div>
    </div>

    <div class="Nhw0IwszjvREbTflQCC5 menulist-wrap">
      <ul class="WP4OJFpuaeK0siGCKAop menulist">
        <li
          class="_nFA6Niz9YzjHuesIJKg BfzjZkte01XMmt7SD6tg"
          @click="jumpUrl('report', { current: 0 })"
        >
          <div class="h4cR2qROZGaQg92ZpG2y">
            <div
              class="blXLPejbalUrq5IycYVR JYYL9fMHbqMw83UNBCCw"
              style="width: 0.4rem; height: 0.4rem"
            >
              <svg-icon classNameQita icon-class="icon-mine30Item1" />
            </div>
            <span class="_30PUwQvVXtVh5D7EL9w mine-menulist-label">
              {{ $t('mine._function2') }}
            </span>
          </div>
          <div class="m1oUoLwKabgKD2uQ3ToE">
            <p
              style="
                display: -webkit-box;
                overflow: hidden;
                text-overflow: ellipsis;
                vertical-align: middle;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                margin-right: 0.1rem;
                color: var(--theme-primary-color);
                max-width: 3.2rem;
                min-width: 2.6rem;
                text-align: right;
                word-break: break-word;
              "
            >
              Detalhes, apostas, relatórios, recuperar saldo
            </p>
            <svg-icon className="i" icon-class="comm_icon_fh--svgSprite:all" />
          </div>
        </li>
        <li
          class="_nFA6Niz9YzjHuesIJKg BfzjZkte01XMmt7SD6tg"
          @click="
            jumpUrl(userInfo.set_withdraw_password ? 'withdraw' : 'security')
          "
        >
          <div class="h4cR2qROZGaQg92ZpG2y">
            <div
              class="blXLPejbalUrq5IycYVR JYYL9fMHbqMw83UNBCCw"
              style="width: 0.4rem; height: 0.4rem"
            >
              <svg-icon classNameQita icon-class="icon-mine30Item2" />
            </div>
            <span class="_30PUwQvVXtVh5D7EL9w mine-menulist-label">
              {{ $t('mine._GestãoRetiradas') }}
            </span>
          </div>
          <div class="m1oUoLwKabgKD2uQ3ToE">
            <svg-icon className="i" icon-class="comm_icon_fh--svgSprite:all" />
          </div>
        </li>
        <li
          class="_nFA6Niz9YzjHuesIJKg BfzjZkte01XMmt7SD6tg"
          @click="openUrl('promote')"
        >
          <div class="h4cR2qROZGaQg92ZpG2y">
            <div
              class="blXLPejbalUrq5IycYVR JYYL9fMHbqMw83UNBCCw"
              style="width: 0.4rem; height: 0.4rem"
            >
              <svg-icon classNameQita icon-class="icon-mine30Item3" />
            </div>
            <span class="_30PUwQvVXtVh5D7EL9w mine-menulist-label">
              {{ $t('toolbarConter._Promoção') }}
            </span>
          </div>
          <div class="m1oUoLwKabgKD2uQ3ToE">
            <div class="scroll-container">
              <div class="scroll-text">
                <div>Receba milhões de bônus</div>
                <div style="margin-left: 0.1rem">Receba milhões de bônus</div>
              </div>
            </div>
            <svg-icon className="i" icon-class="comm_icon_fh--svgSprite:all" />
          </div>
        </li>
        <li
          class="_nFA6Niz9YzjHuesIJKg BfzjZkte01XMmt7SD6tg"
          @click="jumpUrl('setting')"
        >
          <div class="h4cR2qROZGaQg92ZpG2y">
            <div
              class="blXLPejbalUrq5IycYVR JYYL9fMHbqMw83UNBCCw"
              style="width: 0.4rem; height: 0.4rem"
            >
              <svg-icon classNameQita icon-class="icon-mine30Item4" />
            </div>
            <span class="_30PUwQvVXtVh5D7EL9w mine-menulist-label">
              {{ $t('mine._Dados') }}
            </span>
          </div>
          <div class="m1oUoLwKabgKD2uQ3ToE">
            <svg-icon className="i" icon-class="comm_icon_fh--svgSprite:all" />
          </div>
        </li>
        <li
          class="_nFA6Niz9YzjHuesIJKg BfzjZkte01XMmt7SD6tg"
          @click="jumpUrl('securityConter')"
        >
          <div class="h4cR2qROZGaQg92ZpG2y">
            <div
              class="blXLPejbalUrq5IycYVR JYYL9fMHbqMw83UNBCCw"
              style="width: 0.4rem; height: 0.4rem"
            >
              <svg-icon classNameQita icon-class="icon-mine30Item5" />
            </div>
            <span class="_30PUwQvVXtVh5D7EL9w mine-menulist-label">
              {{ $t('mine._Segurança') }}
            </span>
          </div>
          <div class="m1oUoLwKabgKD2uQ3ToE">
            <svg-icon className="i" icon-class="comm_icon_fh--svgSprite:all" />
          </div>
        </li>
        <li class="_nFA6Niz9YzjHuesIJKg BfzjZkte01XMmt7SD6tg">
          <div class="h4cR2qROZGaQg92ZpG2y">
            <div
              class="blXLPejbalUrq5IycYVR JYYL9fMHbqMw83UNBCCw"
              style="width: 0.4rem; height: 0.4rem"
            >
              <svg-icon classNameQita icon-class="icon-mine30Item6" />
            </div>
            <span class="_30PUwQvVXtVh5D7EL9w mine-menulist-label">
              {{ $t('components._Encontre_nos') }}
            </span>
          </div>
          <div class="m1oUoLwKabgKD2uQ3ToE">
            <p
              style="
                margin-right: 0.1rem;
                color: var(--theme-primary-color);
              "
            >
              Evitar que o site não abra
            </p>
            <svg-icon className="i" icon-class="comm_icon_fh--svgSprite:all" />
          </div>
        </li>
        <li
          class="_nFA6Niz9YzjHuesIJKg BfzjZkte01XMmt7SD6tg"
          @click="$router.push({ name: 'notice' })"
        >
          <div class="h4cR2qROZGaQg92ZpG2y">
            <div
              class="blXLPejbalUrq5IycYVR JYYL9fMHbqMw83UNBCCw"
              style="width: 0.4rem; height: 0.4rem"
            >
              <svg-icon classNameQita icon-class="icon-mine30Item7" />
            </div>
            <span class="_30PUwQvVXtVh5D7EL9w mine-menulist-label">
              {{ $t('mine._FAQ') }}
            </span>
          </div>
          <div class="m1oUoLwKabgKD2uQ3ToE">
            <svg-icon className="i" icon-class="comm_icon_fh--svgSprite:all" />
          </div>
        </li>
        <li
          class="_nFA6Niz9YzjHuesIJKg BfzjZkte01XMmt7SD6tg"
          @click="
            $router.push({
              name: 'notice',
              query: {
                active: 4
              }
            })
          "
        >
          <div class="h4cR2qROZGaQg92ZpG2y">
            <div
              class="blXLPejbalUrq5IycYVR JYYL9fMHbqMw83UNBCCw"
              style="width: 0.4rem; height: 0.4rem"
            >
              <svg-icon classNameQita icon-class="icon-mine30Item8" />
            </div>
            <span class="_30PUwQvVXtVh5D7EL9w mine-menulist-label">
              {{ $t('mine._BônusdeSugestão') }}
            </span>
          </div>
          <div class="m1oUoLwKabgKD2uQ3ToE">
            <svg-icon className="i" icon-class="comm_icon_fh--svgSprite:all" />
          </div>
        </li>
        <li class="_nFA6Niz9YzjHuesIJKg BfzjZkte01XMmt7SD6tg">
          <div class="h4cR2qROZGaQg92ZpG2y">
            <div
              class="blXLPejbalUrq5IycYVR JYYL9fMHbqMw83UNBCCw"
              style="width: 0.4rem; height: 0.4rem"
            >
              <svg-icon classNameQita icon-class="icon-mine30Item9" />
            </div>
            <span class="_30PUwQvVXtVh5D7EL9w mine-menulist-label">
              {{ $t('mine._Façaloginnodispositivo') }}
            </span>
          </div>
          <div class="m1oUoLwKabgKD2uQ3ToE">
            <svg-icon className="i" icon-class="comm_icon_fh--svgSprite:all" />
          </div>
        </li>

        <li
          class="_nFA6Niz9YzjHuesIJKg BfzjZkte01XMmt7SD6tg"
          @click="Saireiniciarsess"
        >
          <div class="h4cR2qROZGaQg92ZpG2y">
            <div
              class="blXLPejbalUrq5IycYVR JYYL9fMHbqMw83UNBCCw"
              style="width: 0.4rem; height: 0.4rem"
            >
              <svg-icon classNameQita icon-class="icon-mine30Item10" />
            </div>
            <span class="_30PUwQvVXtVh5D7EL9w mine-menulist-label">
              {{ $t('mine._Sair') }}
            </span>
          </div>
          <div class="m1oUoLwKabgKD2uQ3ToE">
            <svg-icon className="i" icon-class="comm_icon_fh--svgSprite:all" />
          </div>
        </li>
      </ul>
    </div>
    <APopup :isShow="isShow" @_remove="_remove"></APopup>
    <MyToast
      :isShow="isMyToast"
      @cancel="isMyToast = false"
      @confirm="openConfirm"
      :model="{
        title: $t('components._Falhanocheckin'),
        message: message,
        buttomValue: $t('components._Irparadepsito'),
        type: 'fail' //success fail
      }"
    ></MyToast>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Dialog } from 'vant';
import APopup from '@/components/Idioma-popup/index.vue';
import { dailySignIn, doDailySign } from '@/apis/modules/detail.js';
import MyToast from '@/components/MyToast/index.vue';
import { Toast } from 'vant';

export default {
  name: 'records',
  computed: {
    // ...mapState(['popList','userInfo','moneyInfo'])
    popList() {
      return this.$store.state.popList || [];
    },
    userInfo() {
      if (this.$store.state.userInfo && this.$store.state.userInfo.vip_info) {
        return this.$store.state.userInfo;
      } else {
        return { vip_info: {} };
      }
    },

    moneyInfo() {
      return this.$store.state.moneyInfo;
    },
    ...mapState(['vuex_token_head'])
  },
  components: {
    APopup,
    MyToast
  },
  data() {
    return {
      coloImgactivity: require('@/assets/mine30/mine30Bg.webp'),
      mineBoxBgImg: require('@/assets/mine30/mine30BoxBg.webp'),
      isShow: false,
      animate__manimated: false,
      conutryPosion: '-8.11143rem -3.16929rem',
      userBalance: '0,00',
      chooseInfo: 'name',
      isShowChoose: false,
      activeDay: 1,
      showScrollBtnleft: false,
      showScrollBtnRight: true,
      showTipsBox: false,
      dailySignIn: {},
      isMyToast: false,
      message: false,
      mesnComenste: false
    };
  },
  created() {
    if (this.$store.state.config.currency == 'R$') {
      this.conutryPosion = '-8.11143rem -3.16929rem';
    } else if (this.$store.state.config.currency == '$') {
      this.conutryPosion = '-7.25143rem -7.47929rem';
    } else if (this.$store.state.config.currency == '₹') {
      this.conutryPosion = '-8.11143rem -1.04029rem';
    } else if (this.$store.state.config.currency == '¢') {
      this.conutryPosion = '-2.14143rem -8.24029rem';
    } else if (this.$store.state.config.currency == 'M$') {
      this.conutryPosion = '-8.11143rem -4.92629rem';
    } else if (this.$store.state.config.currency == '₦') {
      this.conutryPosion = '-1.05143rem -7.98829rem';
    } else if (this.$store.state.config.currency == '₱') {
      this.conutryPosion = '-8.11143rem -2.80929rem';
    }
    this.showBalance();
    dailySignIn({}).then(({ code, data, msg }) => {
      this.dailySignIn = data;
      this.activeDay = data.now_day;
    });
  },
  watch: {
    moneyInfo: {
      handler(val) {
        this.showBalance();
      },
      deep: true
    }
  },
  methods: {
    openConfirm() {
      this.isMyToast = false;
      this.mesnComenste = false;
      setTimeout(() => {
        this.$store.commit('isDeposit', true);
      }, 300);
    },
    checkLogin() {
      if (!this.vuex_token_head) {
        let rememberPassword = window.localStorage.getItem('rememberPassword');
        if (rememberPassword && rememberPassword.length) {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 1]);
        } else {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 0]);
        }
        return false;
      }
      return true;
    },
    ReceberTudo() {
      if (!this.checkLogin()) return;
      doDailySign({
        activity: 'lossSubsidy'
      }).then(({ code, data, msg }) => {
        //404
        if (code == 1) {
          this.isMyToast = true;
          this.message = msg;
          return false;
        } else if (code == 0) {
          Toast.success(msg);
          this.getNotification();
        } else {
          Toast.loading(msg);
        }
      });
    },
    toItemFunction(num) {
      if (num == 1) {
        this.jumpUrl('yuebao');
      }
      if (num == 2) {
        this.jumpUrl('report');
      }
      if (num == 3) {
        this.jumpUrl(
          this.userInfo.set_withdraw_password ? 'withdraw' : 'security',
          {
            current: 2
          }
        );
      }
      if (num == 4) {
        this.jumpUrl('vip');
      }
      if (num == 5) {
        this.jumpUrl('promote');
      }
      if (num == 6) {
        this.jumpUrl('setting');
      }
      if (num == 7) {
        this.jumpUrl('securityConter');
      }
      if (num == 8) {
        this.isShow = !this.isShow;
      }
      if (num == 9) {
        this.jumpUrl('notice');
      }
      if (num == 10) {
        // this.jumpUrl('');
      }
      if (num == 11) {
        this.jumpUrl('device-info');
      }
    },
    convertEmToPx(emValue) {
      const fontSize = parseFloat(
        window.getComputedStyle(document.documentElement).fontSize
      );
      return emValue * fontSize;
    },
    handleScroll() {
      const container = this.$refs.scrollContainer;
      console.log(container.scrollLeft, 'container.scrollLeft');
      // 左侧到底
      if (container.scrollLeft == 0) {
        this.showScrollBtnleft = false;
        this.showScrollBtnRight = true;
      } else {
        this.showScrollBtnleft = true;
      }
      // 右侧到底
      if (
        container.scrollWidth - container.scrollLeft <=
        container.clientWidth
      ) {
        this.showScrollBtnleft = true;
        this.showScrollBtnRight = false;
      } else {
        this.showScrollBtnRight = true;
      }
    },
    toLeft() {
      const container = this.$refs.scrollContainer;
      container.scrollLeft -= this.convertEmToPx(6.695);
    },
    toRight() {
      const container = this.$refs.scrollContainer;
      container.scrollLeft += this.convertEmToPx(6.695);
    },
    goBack() {
      this.$router.go(-1);
    },
    jumpUrl(path, params) {
      if (this.vuex_token_head) {
        this.openUrl(path, params);
      } else {
        this.$store.commit('isRecord');
        this.$store.commit('publicFun', ['isRecordType', 1]);
      }
    },
    animate_conter(e) {
      //
      this.animate__manimated = true;
      this.getBalance();
      let time = setTimeout(() => {
        clearTimeout(time);
        this.animate__manimated = false;
      }, 300);
    },
    showBalance() {
      this.userBalance = this.$store.state.config.balance_no_bonus.includes(
        'user_center'
      )
        ? this.moneyInfo.balance_coin_str
        : this.moneyInfo.balance_total_str;
    },
    Saireiniciarsess() {
      let _this = this;
      Dialog.confirm({
        title: this.$t('mine._Lembrete'),
        message: this.$t('mine._Desejaterminarsessãodaconta'),
        confirmButtonText: this.$t('mine._Cancelar'),
        cancelButtonText: this.$t('mine._Confirmarsaída')
      })
        .then(() => {})
        .catch(() => {
          _this.$router.push({ name: 'home' });
          this.$vuex('vuex_token_head', {});
          this.$vuex('vuex_token', '');
          setTimeout(() => {
            location.reload();
          });
        });
    },
    _remove() {
      //
      this.isShow = false;
    },
    tabFun(e) {
      this.$store.commit('active', e);
    },
    stickyScroLL(e) {},

    // 获取指定路由的徽章数量
    getBadgeCount() {
      if (this.moneyInfo && this.moneyInfo.have_message) {
        return this.moneyInfo.have_message;
      } else {
        return 0;
      }
    },

    // 格式化徽章数字显示
    formatBadgeCount(count) {
      if (count <= 0) return '';
      if (count > 99) return '99+';
      return count.toString();
    },
    showDeposit() {
      if (this.vuex_token_head) {
        this.$store.commit('isDeposit', true);
      } else {
        this.$store.commit('isRecord');
        this.$store.commit('publicFun', ['isRecordType', 1]);
      }
    }
  }
};
</script>
<style scoped>
.mine_conten {
  min-height: 100vh;
  background-repeat: no-repeat;
  background-color: var(--theme-main-bg-color);
  .checkInBox {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0.3rem 0.25rem 0.2rem;
    border-radius: 0.2rem;
    padding: 0.1rem 0.2rem;
    background: var(--theme-btm-bg-color);
    box-shadow: 0 0.03rem 0.1rem rgba(0, 0, 0, 0.06);
    .arrow-left,
    .arrow-right {
      position: absolute;
      width: 0.36rem;
      height: 0.36rem;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.36rem;
      bottom: 0.58rem;
      background-color: rgba(0, 0, 0, 0.2);
      color: #fff;
      z-index: 1000;
    }
    .arrow-left {
      left: 0.08rem;
    }
    .arrow-right {
      right: 0.08rem;
    }
    .checkInMoneyBox {
      position: relative;
      z-index: 1;
      width: 1rem;
      height: 1.32rem;
      border: 0.01rem solid var(--theme-text-color);
      border-radius: 0.14rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .checkInMoneyBox_itemMoneyText {
        color: var(--theme-secondary-color-finance);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;
        width: 100%;
        height: 0.33rem;
        font-size: 0.24rem;
        line-height: 0.33rem;
        text-align: center;
      }
      .checkInMoneyBox_itemMoneyImg {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0.48rem;
        height: 0.48rem;
        margin: 0.03rem 0;
      }
      .checkInMoneyBox_itemDay {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.35rem;
        padding-top: 0;
        color: #fff;
        font-size: 0.2rem;
      }
    }
    .active {
      border-color: #20f511;
      .checkInMoneyBox_itemDay {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.35rem;
        padding-top: 0;
        color: #fff;
        font-size: 0.2rem;
        div {
          background: #20f511;
          width: 0.8rem;
          height: 0.35rem;
          border-radius: 0.5rem;
          padding: 0 0.05rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
.mine-function-item {
  margin-top: 0.3rem;
  width: 1.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--theme-text-color);
  text-align: center;
  position: relative;
  .item-activity {
    color: rgb(255, 255, 0);
    background-color: red;
    height: 0.26rem;
    text-align: center;
    border-radius: 0.13rem 0.13rem 0.13rem 0;
    font-size: 0.18rem;
    font-weight: 400;
    line-height: 0.26rem;
    position: absolute;
    left: 50%;
    right: auto;
    transform: translateY(-50%);
    min-width: 0.32rem;
    padding: 0 0.08rem;
  }
  .item-activity:before {
    content: '';
    display: inline-block;
    position: absolute;
    bottom: -0.06rem;
    z-index: 20;
    left: 0;
    width: 0;
    height: 0;
    border-left: 0.079rem solid red;
    border-top: 0.066rem solid transparent;
    border-bottom: 0.066rem solid transparent;
    font-size: 0;
  }
  .item-svg {
    width: 0.47rem;
    height: 0.47rem;
    position: absolute;
    left: 0;
    top: 0;
  }
  .item-text {
    height: auto;
    max-height: 0.66rem;
    line-height: 0.33rem;
    font-size: 0.24rem;
    margin-top: 0.1rem;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.moneybox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 1.06rem;
  font-size: 0.24rem;
  position: relative;
  flex-grow: 1;
  img {
    width: 0.53rem;
    height: auto;
    display: block;
    margin-bottom: 0.02rem;
  }
  span {
    max-height: 0.66rem;
    line-height: 0.33rem;
    width: 100%;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
    word-break: break-word;
    font-size: 0.24rem;
  }
}
.moneybox1:after {
  position: absolute;
  top: -0.05rem;
  right: 0;
  bottom: 0;
  display: block;
  width: 0.01rem;
  height: 0.4rem;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.24);
  content: '';
}

.Nhw0IwszjvREbTflQCC5 {
  font-size: 0.24rem;
  backdrop-filter: brightness(2.5);
  padding: 0.2rem 0;
}

.Nhw0IwszjvREbTflQCC5 .rebPmbNdLSySZKEqLMYm {
  background-color: var(--theme-main-bg-color);
}

.Nhw0IwszjvREbTflQCC5 .BfzjZkte01XMmt7SD6tg {
  color: var(--theme-primary-color);
  height: 0.8rem;
  margin-top: 0.14rem;
  padding: 0 0.18rem 0 0.28rem;
  font-size: 0.24rem;
  border-radius: 0.16rem;
}

.BfzjZkte01XMmt7SD6tg:first-child {
  margin-top: 0;
}

.Nhw0IwszjvREbTflQCC5 .BfzjZkte01XMmt7SD6tg .mine-menulist-label {
  color: var(--theme-text-color-darken);
}

.Nhw0IwszjvREbTflQCC5 .BfzjZkte01XMmt7SD6tg .promoteRight > i {
  display: none !important;
}

.Nhw0IwszjvREbTflQCC5 .BfzjZkte01XMmt7SD6tg .promoteRight p {
  height: 0.28rem;
}
.WP4OJFpuaeK0siGCKAop {
  padding: 0 0.26rem;
}

.WP4OJFpuaeK0siGCKAop ._nFA6Niz9YzjHuesIJKg {
  -ms-flex-pack: justify;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  background-color: var(--theme-main-bg-color);
}

.scroll-container {
  width: 100%; /* 容器宽度 */
  overflow: hidden; /* 隐藏超出部分 */
  white-space: nowrap; /* 防止文本换行 */
  position: relative; /* 定位容器 */
  margin-right: 0.1rem;
  color: var(--theme-primary-color);
  max-width: 3.2rem;
  min-width: 2.6rem;
  display: flex;
  align-items: center;
}

.scroll-text {
  max-width: 2.8rem;
  min-width: 2.6rem;
  display: flex;
  align-items: center;
  animation: scrollText1 3.44s linear infinite;
  text-align: right;
}

/* .scroll-text2 {
  display: inline-block;
  position: absolute;
  animation: scrollText2 4s linear infinite;
  min-width: 50%;
  display: inline-block;
  margin-left: 0.1rem;
} */

@keyframes scrollText1 {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(calc(-100% - 0.15rem));
  }
}

/* @keyframes scrollText2 {
  0% {
    transform: translateX(calc(100% + 0.1rem));
  } 
  100% {
    transform: translateX(calc(0% + 0.1rem));
  } 
} */
.WP4OJFpuaeK0siGCKAop ._nFA6Niz9YzjHuesIJKg .h4cR2qROZGaQg92ZpG2y,
.WP4OJFpuaeK0siGCKAop ._nFA6Niz9YzjHuesIJKg .m1oUoLwKabgKD2uQ3ToE {
  -ms-flex-negative: 0;
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  flex-shrink: 0;
}

.WP4OJFpuaeK0siGCKAop ._nFA6Niz9YzjHuesIJKg ._30PUwQvVXtVh5D7EL9w {
  margin-left: 0.24rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.WP4OJFpuaeK0siGCKAop ._nFA6Niz9YzjHuesIJKg .m1oUoLwKabgKD2uQ3ToE {
  -ms-flex-pack: end;
  justify-content: end;
}

.WP4OJFpuaeK0siGCKAop
  ._nFA6Niz9YzjHuesIJKg
  .m1oUoLwKabgKD2uQ3ToE
  .eftT5wc3_J0TkWpZUbSf {
  margin-left: 0.1rem;
}

.WP4OJFpuaeK0siGCKAop
  ._nFA6Niz9YzjHuesIJKg
  .m1oUoLwKabgKD2uQ3ToE
  .o7KUVQuKEMNzxFB1eGIA {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow: hidden;
  text-align: right;
  width: 2.6rem;
}

.m1oUoLwKabgKD2uQ3ToE .i {
  color: var(--theme-color-line);
  height: 0.24rem;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
  width: 0.24rem;
}

.WP4OJFpuaeK0siGCKAop ._nFA6Niz9YzjHuesIJKg .h4cR2qROZGaQg92ZpG2y {
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
}

.WP4OJFpuaeK0siGCKAop
  ._nFA6Niz9YzjHuesIJKg
  .h4cR2qROZGaQg92ZpG2y
  .JYYL9fMHbqMw83UNBCCw {
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.WP4OJFpuaeK0siGCKAop
  ._nFA6Niz9YzjHuesIJKg
  .h4cR2qROZGaQg92ZpG2y.SZo2b82I9zuoWxRiuvOg {
  width: 2.6rem;
}

.J5dtKM_LB6fse7jhX2hk {
  overflow: hidden;
  position: relative;
  width: 100%;
}

.J5dtKM_LB6fse7jhX2hk.QF3VjOqeGp_QDYsZS4Ei {
  overflow: visible;
  text-align: center;
}

.J5dtKM_LB6fse7jhX2hk .MtFB4D3SHXXdqKU0qelp {
  height: 100%;
  left: 0;
  position: absolute;
}

.J5dtKM_LB6fse7jhX2hk .kNDhRFHNQ398GxjnCVlg {
  position: absolute;
  text-align: center;
  top: 0;
  width: 100%;
}

.J5dtKM_LB6fse7jhX2hk .YumY578c3s4HnIJXRiBw i {
  color: var(--theme-primary-font-color);
  font-size: 0.22rem;
}

.nUtoDOFYqni_cq_dHUjg {
  grid-gap: 0.1rem;
  -ms-flex-align: center;
  align-items: center;
  display: grid;
  -ms-flex: 1;
  flex: 1;
  font-size: 0.18rem;
  gap: 0.1rem;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
}

.nUtoDOFYqni_cq_dHUjg .FPKXpabqN25lBr4IA7LQ {
  background-color: rgba(0, 0, 0, 0.08);
  border-bottom: 0.01rem solid hsla(0, 0%, 100%, 0.5);
  border-radius: 0.1rem;
  height: 0.2rem;
}

.nUtoDOFYqni_cq_dHUjg .SC6yMRCGE2upeyEdgibm {
  background-color: var(--theme-secondary-color-success);
  border-radius: 0.1rem;
}

.nUtoDOFYqni_cq_dHUjg .u5sLSrD0KWEulumHoUzc {
  color: #fff;
  line-height: 0.2rem;
}

.nUtoDOFYqni_cq_dHUjg .i9WaVhztJIXx90Q1PPLD {
  display: grid;
  -ms-flex: 1;
  flex: 1;
  grid-template-columns: auto 1fr;
  align-items: center;
}
.Rp9bR9P03_qFsh1PnGSc {
  max-width: 1.5rem;
}

.Rp9bR9P03_qFsh1PnGSc .inner-text {
  text-align: left;
}

.CToeIaCnZ7Jr3D1XKTxw {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 0.14rem 0 0.12rem;
  position: relative;
}

.CToeIaCnZ7Jr3D1XKTxw .DiNiMDlhVGqZnjLoStS4 {
  -ms-flex-pack: end;
  display: -ms-flexbox;
  display: flex;
  justify-content: end;
  align-items: center;
  font-size: 0.2rem;
  font-weight: 200;
  margin-bottom: 0.32rem;
}

.CToeIaCnZ7Jr3D1XKTxw .DiNiMDlhVGqZnjLoStS4 .So_waOZgg7qEl0wURIQz {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
}

.CToeIaCnZ7Jr3D1XKTxw .DiNiMDlhVGqZnjLoStS4 .So_waOZgg7qEl0wURIQz .imageWrap {
  color: var(--theme-primary-color);
  font-size: 0.4rem;
  width: 0.4rem;
  height: 0.4rem;
}

.CToeIaCnZ7Jr3D1XKTxw .SVLWJ4WJI54O4lWBc7yk {
  display: -ms-flexbox;
  display: flex;
}

.wJ30VxmrZK3Y5gTd1Zq0 {
  color: var(--theme-mine-icon-color);
}

.VOgj9FBCnkozjr2NA7rl .refresh-icon {
  color: var(--theme-mine-icon-color) !important;
  width: 0.4rem;
  height: 0.4rem;
}

.vy918omw_N7rBkJ235XX .iw9FDOIygJyoQtUHSJAg > div {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.18rem;
}

.glbY5bkp9x7KTYOGrdBC {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
}

.CToeIaCnZ7Jr3D1XKTxw .zvrVqQuEWSzu7Nsavegl {
  -ms-flex-pack: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
}

.CToeIaCnZ7Jr3D1XKTxw .P_VF1DJcPs_q4ieRYz7n {
  border-radius: 50%;
  margin-right: 0.16rem;
  width: 0.98rem;
  height: 0.98rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.CToeIaCnZ7Jr3D1XKTxw .NeL_d0h5i7Kr9xdDCTty {
  font-size: 0.24rem;
  margin-bottom: 0.09rem;
}

.CToeIaCnZ7Jr3D1XKTxw .EpCtJEz_E_WMlMB6HeaI {
  margin-right: 0.1rem;
}

.CToeIaCnZ7Jr3D1XKTxw .Fn6L7w5ZEXiwo2fTNrRn {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.32rem;
}

.B8Z5jNPFB44UUahGOFBH {
  color: var(--theme-text-color);
}

.CToeIaCnZ7Jr3D1XKTxw .Fn6L7w5ZEXiwo2fTNrRn .DnC6T98QN772WLPs1ooC {
  margin: 0 0.1rem;
}

.CToeIaCnZ7Jr3D1XKTxw
  .Fn6L7w5ZEXiwo2fTNrRn
  .DnC6T98QN772WLPs1ooC
  .HiI_svzoqAjA6nNwGufG {
  color: var(--theme-text-color);
  font-size: 0.2rem;
}

.CToeIaCnZ7Jr3D1XKTxw
  .Fn6L7w5ZEXiwo2fTNrRn
  .DnC6T98QN772WLPs1ooC
  .UNEMFCOoFUG1wM5qb0v8
  span {
  -ms-flex-align: center;
  align-items: center;
  display: inline-block;
  display: -ms-flexbox;
  display: flex;
  max-width: 2.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.CToeIaCnZ7Jr3D1XKTxw .Fn6L7w5ZEXiwo2fTNrRn .VOgj9FBCnkozjr2NA7rl {
  border: none;
  position: inherit !important;
}

.Fn6L7w5ZEXiwo2fTNrRn .VOgj9FBCnkozjr2NA7rl .count-to {
  border-color: var(--theme-text-color-darken) !important;
  color: var(--theme-text-color-darken) !important;
  border-bottom: 0.02rem solid var(--theme-text-color-darken);
  display: inline-block;
  font-size: 0.32rem !important;
  margin: 0 0.1rem !important;
  max-width: 2.5rem;
}

.CToeIaCnZ7Jr3D1XKTxw
  .Fn6L7w5ZEXiwo2fTNrRn
  .VOgj9FBCnkozjr2NA7rl
  .refresh-icon {
  color: var(--theme-mine-icon-color) !important;
  font-size: 0.28rem;
}

.CToeIaCnZ7Jr3D1XKTxw
  .Fn6L7w5ZEXiwo2fTNrRn
  .VOgj9FBCnkozjr2NA7rl
  .currency-triangle {
  -webkit-transform: translate(-50%, 0.01rem) rotate(45deg);
  transform: translate(-50%, 0.01rem) rotate(45deg);
}

.PIj1PfbzHvacLB3SeEjQ {
  color: var(--theme-text-color-darken);
  margin-right: 0.06rem;
}

.SVLWJ4WJI54O4lWBcsdfsdf {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

._icon_1u010_65 {
  cursor: pointer;
  width: 0.88rem;
  height: 0.88rem;
  margin-right: 0.2rem;
}

.no-login-left {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.un-login-info-tips-label {
  color: var(--theme-text-color);
  font-size: 0.24rem;
  line-height: 1.35;
}
._action_1u010_97 {
  font-size: 0.24rem;
  color: var(--theme-text-color-darken);
  cursor: pointer;
  margin: 0 0.05rem;
}

.crcd82r1PVsQivOcCftk {
  display: flex;
  flex-direction: row;
  margin-top: 0.2rem;
}

.crcd82r1PVsQivOcCftk button {
  height: 0.51rem;
  font-size: 0.22rem;
  width: 1.2rem;
  padding: 0 0.2rem;
  border-radius: 0.1rem;
  margin-left: 0.2rem;
}
</style>
